export interface ICarouselOrder {
    id: number;
    providerName: string;
    priority: number;
    isLive: boolean;
}

export class MediationTableRow {
    constructor(public carouselItem: ICarouselOrder, public isProviderFallback: boolean, public backgroundColor: string, public textColor: string, public fontStyle: string) { }
}


// WEBPACK FOOTER //
// ./src/app/mediation/mediation.model.ts